module.exports = "/video-roulette/img/purple-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/purple-ball.png
// module id = 2440
// module chunks = 10